define(['vue'], function(Vue){
    return new Vue();
});


//////////////////
// WEBPACK FOOTER
// ../common/event-bus.js
// module id = 7
// module chunks = 0 1 2 3 4 5 6